module.exports = __webpack_public_path__ + "img/picture_kmskcspvip05.347f21d3.png";